
/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains the Employee Report search filter component
------------------------------------------------------------------------------------------------------- */

import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import '../../ReportsCommonStyles/CommonSearchFilterStyle.css';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { jobTypeOptions } from '../../../../utils/constants';
import { Icons } from '../../../../utils/GlobalIcons';
import ActionButtonWithIcon from '../../../../Components/custom_components/CustomButtons/ActionButtonWithIcon/ActionBtnWithIcon';

function WorkforceCombinedReportFilter({
  tableTitle,
  searchFilter,
  on_change_value, on_page_count_update,
  onExportPDF,
  onExportExcel,
  isExportingPDF,
  isExportingExcel

}) {

  const formik = useFormik({
    initialValues: {
      employee_name: '',
      job_type: "",
      worksite_name: '',

    },
    onSubmit: values => {
      searchFilter(values);
    },
  });

  const resetFilter = () => {
    on_change_value(1)
    on_page_count_update(25)
    formik.resetForm();
    searchFilter({
      employee_name: '',
      job_type: "",
      worksite_name: '',

    });
  };
  const breadcrumbs = ["Reports", tableTitle];
  
  return (
    <div className="common-search-filter-container">
      <div className="common-search-filter-sub-container">
        <div className="common-search-header">
          <div className="common-search-left">
            <div className="common-table-title">{tableTitle}</div>
            <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
          </div>
          <div className="common-export-buttons-container">
            <ActionButtonWithIcon
              label="Export PDF"
              onClick={onExportPDF}
              icon={Icons.PdfIcon}
              backgroundColor="#ffffff"
              hoverColor="#fef2f2"
              labelColor="#000000"
              borderColor="#e5e7eb"
              iconColor="#dc2626"
              loading={isExportingPDF}
            />

            <ActionButtonWithIcon
              label="Export Excel"
              onClick={onExportExcel}
              icon={Icons.ExcelIcon}
              backgroundColor="#ffffff"
              hoverColor="#f0fdf4"
              labelColor="#000000"
              borderColor="#e5e7eb"
              iconColor="#16a34a"
              loading={isExportingExcel}
            />
          </div>
        </div>

        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <CustomTextFieldWithIcon
              id="employee_name"
              name="employee_name"
              placeholder="Employee Name"
              value={formik.values.employee_name}
              onChange={formik.handleChange}
              width="200px"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <CustomTextFieldWithIcon
              id="worksite_name"
              name="worksite_name"
              placeholder="Worksite Name"
              value={formik.values.worksite_name}
              onChange={formik.handleChange}
              width="200px"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomSelectDropdown
              name="job_type"
              placeholder="Select Job Type"
              options={jobTypeOptions}
              value={jobTypeOptions.find(opt => opt.value === formik.values.job_type) || ''}
              onChange={opt => formik.setFieldValue('job_type', opt?.value || '')}
              onBlur={formik.handleBlur}
              isMulti={false}
              width="200px"
            />
          </Grid>


          <Grid item xs={12} sm={12} md={3}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ActionButton
                  // onClick={formik.handleSubmit}
                  onClick={() => {
                    on_change_value(1)
                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                  }}
                  btnDisable={false}
                  label="Search"
                  btnType="primary"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <ActionButton
                  onClick={resetFilter}
                  label="Reset"
                  btnType="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default WorkforceCombinedReportFilter;